import { Navigate, Link, useParams } from 'react-router-dom';
import { ArrowLeft } from '@carbon/icons-react';
import { canAccessArticle, getArticleBySlug } from './docs.helpers';
import { useCurrentUserRole } from './useCurrentUserRole';
import styles from './Docs.module.scss';

export default function DocsArticlePage() {
  const { slug = '' } = useParams<{ slug: string }>();
  const role = useCurrentUserRole();
  const article = getArticleBySlug(slug);

  if (!article || !canAccessArticle(slug, role)) {
    return <Navigate to="/docs" replace />;
  }

  return (
    <div className={styles.pageContainer}>
      <article className={styles.layoutWide}>
        <header className={styles.articleHeader}>
          <Link to="/docs" className={styles.backLink}>
            <ArrowLeft size={16} aria-hidden />
            Retour au centre d’aide
          </Link>
          <h1 className={styles.articleTitle}>{article.title}</h1>
          <p className={styles.articleSummary}>{article.summary}</p>
        </header>
        <div className={styles.articleBody}>{article.body}</div>
      </article>
    </div>
  );
}
